import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {
	useLabels,
	useSitemap,
	usePrefs,
	useRequestData
} from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import Icon from '../components/Icon';
import { getAttributes } from '../utils/getAttributes';
import { getLinksToDisplay } from '../utils/getLinksToDisplay';
import { handleClick } from '../utils/handleClick';
import { trackGa } from '../utils/trackGa';

const Widget = () => {
	const [pageURL, setPageURL] = useState();
	const [itemId, setItemId] = useState();
	const sitemap = useSitemap();
	const labels = useLabels();
	const prefs = usePrefs();
	const { buttonClasses, buttonStyle, emailHref, iconSize } = prefs;
	const { deviceType, windowId } = useRequestData();

	const showIcons = prefs.showIcons === 'true';
	const isMobile = deviceType === 'MOBILE';

	useEffect(() => {
		if (isBrowser) {
			const { protocol, host, pathname } = window?.location;
			const url = `${protocol}//${host}${pathname}`;

			setPageURL(url);

			const params = new URLSearchParams(window.location.search);
			const vehicles = window?.DDC?.dataLayer?.vehicles;
			const uuid =
				vehicles && vehicles.length === 1 ? vehicles[0]?.uuid : null;
			const id = params.get('itemId') || uuid;

			setItemId(id);
		}
	}, []);

	const linkProps = {
		COPY: {
			key: 'COPY',
			iconName: 'link',
			label: 'COPY_LINK',
			href: '#'
		},
		EMAIL: {
			key: 'EMAIL',
			iconName: 'email',
			label: 'EMAIL_A_FRIEND',
			href: emailHref,
			params: itemId ? `?itemId=${itemId}` : ''
		},
		FACEBOOK: {
			key: 'FACEBOOK',
			iconName: 'facebook',
			label: 'FACEBOOK',
			href: `https://www.facebook.com/sharer.php?display=popup&u=${pageURL}`
		},
		PRINT: {
			key: 'PRINT',
			iconName: 'print',
			label: 'PRINT',
			href: '#'
		},
		TWITTER: {
			key: 'TWITTER',
			iconName: 'twitter',
			label: 'TWITTER',
			href: `https://twitter.com/intent/tweet?url=${pageURL}`
		}
	};

	return (
		<>
			<ul className="nav nav-stacked">
				{getLinksToDisplay(isMobile, prefs).map((link) => (
					<li key={link}>
						<Button
							id={`links-share-${link}`}
							className={buttonClasses}
							bsStyle={buttonStyle}
							onClick={(event) => {
								trackGa(event, link, windowId, buttonStyle);
								handleClick(
									event,
									isMobile,
									linkProps[link].href
								);
							}}
							{...getAttributes(
								buttonClasses,
								labels,
								link,
								linkProps,
								sitemap
							)}
						>
							{showIcons && (
								<Icon
									name={linkProps[link].iconName}
									label={labels.get(linkProps[link].label)}
									size={iconSize}
								/>
							)}
							{!showIcons && labels.get(linkProps[link].label)}
						</Button>
					</li>
				))}
			</ul>

			{/* Using hidden textarea to allow copy-to-clipboard to work */}
			<textarea
				id="links-share-clipboard"
				readOnly
				style={{
					position: 'absolute',
					left: '-99999px'
				}}
				value={pageURL}
			/>
		</>
	);
};

export default Widget;
